/**
 * Links that follow the remembered council. A link with
 * data-awdd-council-link="<anchor>" keeps its server href with no council and
 * goes to <council url>#<anchor> with one, following council-change.
 */

import { current, onChange } from './council.js';

export default function initCouncilLinks() {
	const links = Array.from(document.querySelectorAll('a[data-awdd-council-link]'));
	if (!links.length) return;
	links.forEach((a) => {
		a.dataset.awddBaseHref = a.getAttribute('href') || '';
		// A link that opens the lookup at load goes back to doing so with no council.
		a.dataset.awddHadDialog = a.dataset.awddDialogOpen || '';
		const text = a.querySelector('[data-awdd-council-text]');
		if (text) a.dataset.awddBaseText = text.textContent;
	});

	const render = (council) => {
		links.forEach((a) => {
			const anchor = a.dataset.awddCouncilLink;
			a.setAttribute('href', council && anchor ? `${council.url.replace(/#.*$/, '')}#${anchor}` : a.dataset.awddBaseHref);

			// The lookup opener steps aside once a council is set.
			if (a.dataset.awddHadDialog) {
				if (council) delete a.dataset.awddDialogOpen;
				else a.dataset.awddDialogOpen = a.dataset.awddHadDialog;
			}

			const text = a.querySelector('[data-awdd-council-text]');
			const label = a.dataset.awddCouncilLabel;
			if (text && label) {
				text.textContent = '';
				if (council) {
					const [before, after = ''] = label.split('{short}');
					const name = document.createElement('span');
					name.className = 'notranslate';
					name.textContent = council.short;
					text.append(before, name, after);
				} else {
					text.textContent = a.dataset.awddBaseText;
				}
			}
		});
	};

	render(current());
	onChange(render);
}
